<template>
  <div
    id="container"
    ref="container"
    :style="
      options.series[0].data.length > 0
        ? 'min-height: 400px; width: 100%'
        : 'min-height: 400px; width: 100%; visibility: hidden'
    "
  />
</template>

<script>
import ECharts from "echarts";

const cores = [
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
];

export default {
  name: "BarChartVendas",
  props: {
    dados: {
      type: Array,
    },
  },
  data: () => ({
    myChart: {},
    options: {
      color: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ],
      // tooltip: {},
      grid: {
        left: "5%",
        right: "5%",
        bottom: "0%",
        top: "15%",
        containLabel: true,
        tooltip: {
          formatter: (params) =>
            params.value
              ? parseFloat(params.value.toFixed(2)).toLocaleString("pt-BR", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                })
              : 0,
        },
      },
      xAxis: {
        type: "category",
        // data: ['01/19', '02/19', '03/19', '04/19', '05/19', '06/19'],
        data: [],
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: {},
      series: [
        {
          type: "bar",
          animation: true,
          label: {
            normal: {
              show: true,
              // rotate: 90,
              formatter: (params) =>
                parseFloat(params.value.toFixed(2)).toLocaleString("pt-BR", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                }),
              fontSize: 12,
              position: "top",
              distance: 5,
            },
          },
          data: [],
        },
      ],
    },
  }),
  mounted() {
    this.init();
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    init() {
      let dom = this.$refs.container;
      this.myChart = ECharts.init(dom);
      // if (this.dados.filter((item) => item).length > 0) {
      //   this.myChart.setOption(this.options, true);
      // } else {
      //   return;
      // }
    },
    onResize() {
      window.onresize = () => {
        this.myChart.resize();
      };
    },
  },
  computed: {
    isMobileDevice: function() {
      return (
        typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1
      );
    },
  },
  watch: {
    dados: function(val, oldVal) {
      if (val) {
        let valores = val
          .filter((item) => item)
          .map((item, i) => {
            return {
              value: item?.Valor,
              itemStyle: { color: cores[i] },
            };
          });

        let legenda = val.filter((item) => item).map((item) => item?.Legenda);

        this.options.series[0].data = valores;
        this.options.xAxis.data = legenda;
        if (this.isMobileDevice) {
          this.options.series[0].label.normal.show = false;
        }

        this.myChart.setOption(this.options, true);
      }
    },
  },
};
</script>

<style></style>
